import API from "../../Network/API";
import { isLoaded, isLoading, modules } from "../actions";


//Modules for Project
export async function getModules(dispatch, getUser, id) {
    dispatch(isLoading());
    try {
      var response = await API.post("projectInfo.php", {
        "crop": getUser.corp,
        "ideaId": id,
        "action": "modules",
        "projectId":getUser.projectId
      }, {}, false);
      if (response.status === "True") {
        dispatch(modules(response.data));
      } else {
        dispatch(modules([]));
      }
    } catch (error) {
      console.log(error)
    }
    dispatch(isLoaded());
  }